export var AllowsPayload = {
  POST: true,
  PUT: true,
  DELETE: true
};